//console.log("product.js");

//Details
let details = document.querySelector(".description .details");
let detailsCloneCon = document.querySelector("#details-clone");

if (details) {
  let detailsClone = details.cloneNode(true);
  detailsCloneCon.appendChild(detailsClone);
}

let dropBtn = document.querySelectorAll(".drop-btn");
let dropBlock = document.querySelectorAll(".drop-block");

dropBtn.forEach(function (item, i) {
  item.addEventListener("click", function (event) {
    event.preventDefault();
    controlDrop(i);
  });
});

let controlDrop = function(i){
  dropBtn.forEach(function(item, j){
    if(i != j){
      item.classList.remove("underline");
      dropBlock[j].classList.remove("show");
    } else {
      item.classList.toggle("underline");
      dropBlock[j].classList.toggle("show");
    }
  });
}

//Swipers
let mobileGallery = new Swiper(".swiper-container", {
  loop: true,
  autoHeight: true,
  pagination: {
    el: ".swiper-pagination",
  },
});

let relatedItems = new Swiper(".swiper-containerz", {
  spaceBetween: 10,
  slidesPerView: 2,
  freeMode: true,
});

//Check variant type
let atcBtn = document.querySelector(".atc-btn");
let btnType = atcBtn.dataset.btnType;
let productHandle = atcBtn.dataset.handle;
let varWrap = document.querySelector("#sb-add-to-cart");
let varOptions = varWrap.querySelector(".variant-options");
let defaultDropdown = document.querySelector(".toggle-options-btn");
let defaultDropdownText;
if(defaultDropdown){
  defaultDropdownText = defaultDropdown.innerHTML;
}

let convertToHandle = function(string){
  let handle = string.toLowerCase();
  handle = handle.replace(/\s+/g, "-");
  handle = handle.replace(/[^a-zA-Z0-9-]/g, "");
  return handle;
}

let animateOnChange = function (element, newInnerHTML) {
  Velocity(
    element,
    { opacity: 0 },
    {
      //duration: 100,
      complete: function () {
        element.innerHTML = newInnerHTML;
        Velocity(element, { opacity: 1 }, { duration: 300 });
      },
    }
  );
};

if (btnType == 'no-variant') {
} else if(btnType == 'single-variant') {

  let setVariantId = function (handle, selectedName) {
    let finalVarOne = atcBtn.dataset.variantOne;

    if (finalVarOne != "") {
      let dirtyName = "/products/" + handle + ".js";
      jQuery.getJSON(dirtyName, function (product) {
        //(product);
        let theVariants = product.variants;
        let finalVarOneHandle = convertToHandle(finalVarOne);
        theVariants.forEach(function (jtem, j) {
          let checkHandle = convertToHandle(jtem.option1);

          if (finalVarOneHandle == checkHandle) {
            //console.log(jtem);
            if (jtem.inventory_quantity > 0 || jtem.inventory_policy == "continue") {
              document.querySelector(".toggle-options-btn").innerHTML = selectedName + '<span class="arrow"></span>';
              let dirtyPrice = jtem.price;
              let roundedPrice = dirtyPrice / 100;
              let formatPrice = roundedPrice.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");

              let replaceText = '<span id="item-price" class="animate">$ ' + formatPrice + '</span> - <span id="item-status" class="animate">Add To Cart</span>';
              let atcReplace = atcBtn.querySelector(".inner-btn");
              animateOnChange(atcReplace, replaceText);

              atcBtn.dataset.variantId = jtem.id;
              varWrap.classList.remove('open');
            } else {
              document.querySelector(".toggle-options-btn").innerHTML = selectedName + '<span class="arrow"></span>';
              let atcReplace = atcBtn.querySelector(".inner-btn");
              animateOnChange(atcReplace, "Sold Out");
              atcBtn.dataset.variantId = "";
              varWrap.classList.remove("open");
            }
          }
        });
      });
    }

  };

  //Set the second option when user clicks it
  let theSizes = document.querySelectorAll(".single-variant-btn");
  theSizes.forEach(function (item, i) {
    item.addEventListener("click", function (event) {
      event.preventDefault();
      if (item.querySelector(".size")){
        atcBtn.dataset.variantOne = item.querySelector(".size").innerHTML;
        let writeThis = item.querySelector(".size").innerText;
        setVariantId(productHandle, writeThis);
      }
    });
  });
} else {
  let setMultiDefaults = function (atcBtn, handle) {
    let defaultVarOne = document.querySelector(".line-options a.active").innerText;
    atcBtn.dataset.variantOne = defaultVarOne;

    let dirtyName = "/products/" + handle + ".js";
    jQuery.getJSON(dirtyName, function (product) {
      console.log(product.variants);
      console.log(handle);
      let theVariants = product.variants;

      let optionOne = document.querySelector(".atc-btn").dataset.variantOne;
      let optionOneHandle = convertToHandle(optionOne);

      let variantOptions = document.querySelectorAll('.single-variant-option');

      variantOptions.forEach(function(item,i){
        let optionTwoString = item.querySelector(".size").innerHTML;
        let optionTwoHandle = convertToHandle(optionTwoString);

        let option1Handle = convertToHandle(theVariants[0].option1);
        let option2Handle = convertToHandle(theVariants[0].option2);
        //console.log(option1Handle + " + " + option2Handle);

        if (option1Handle == optionOneHandle) {
          searchOrder = "normal";
        } else if (option2Handle == optionOneHandle) {
          searchOrder = "reverse";
        }

        //console.log(searchOrder);

        if (searchOrder == "normal") {
          theVariants.forEach(function (jtem, j) {
            let checkOne = convertToHandle(jtem.option1);
            let checkTwo = convertToHandle(jtem.option2);

            if (checkOne == optionOneHandle && checkTwo == optionTwoHandle) {
              let inventory = jtem.inventory_quantity;
              let policy = jtem.inventory_policy;
              item.dataset.variantId = jtem.id;
              if (inventory > 0) {
                item.querySelector(".availability").innerHTML = "In Stock";
              } else if (policy == "continue") {

                // let preOrder = ["rising-moon-flask", "large-moon-pendant", "large-carnelian-pendant", "dusk-lighter-case", "medium-moon-pendant", "everyday-ring", "midnight-lighter-case", "small-moon-pendant-in-onyx", "long-dripping-stone-earrings-in-carnelian", "medium-moon-pendant-in-carnelian", "mixed-bead-necklace-in-carnelian-16in-1", "mixed-bead-necklace-in-carnelian-16in", "small-moon-pendant-in-carnelian", "dripping-stone-earrings-in-carnelian", "everyday-earrings-in-carnelian", "carnelian-mermaid-choker", "large-moon-pendant-in-onyx",  "medium-moon-pendant-in-onyx", "dawn-lighter-case", "mixed-bead-necklace-in-onyx-20", "mixed-bead-necklace-in-onyx-16", "everyday-earrings-in-onyx", "small-passante-earrings-in-white", "mixed-bead-necklace-in-onyx-47-5", "mixed-pearl-necklace-16", "mixed-pearl-necklace-47-5", "large-passante-earrings-in-white", "medium-passante-earrings-in-white", "mixed-pearl-necklace-20", "mixed-bead-necklace-in-carnelian-20in", "dripping-stone-earrings-in-vegetable-ivory", "long-dripping-stone-earrings-in-vegetable-ivory", "medium-angelika-earrings-in-vegetable-ivory", "small-angelika-earrings-in-vegetable-ivory", "pyramid-ring-in-onyx", "tilde-ring", "hoops", "small-moon-pendant", "small-angelika-earrings-in-carnelian", "godfather-ring-in-carnelian", "onyx-droplet-pendant", "onyx-droplet-earrings", "teardrop-pouch", "long-teardrop-pouch", "elegant-shoelace-choker-in-vegan-leather"];

                // let preOrder = "vienna-collar-in-carnelian, flamenco-earrings-in-carnelian, flamenco-earrings-in-onyx, long-flamenco-earrings-in-onyx, deco-collar-in-barrel-cut-onyx, magdalene-earrings, barbara-cuff, vessel-necklace, silver-tilde-ring, pearl-moon-ring, circe-pearl-choker, small-spear-pendant-in-carnelian, large-spear-pendant-in-carnelian, small-spear-pendant-in-onyx, large-spear-pendant-in-onyx, spear-earrings-in-onyx, twilight-lighter-case, eclipse-lighter-case, deco-collar-in-carnelian, spear-earrings-in-carnelian, tiny-spear-pendant, tiny-spear-hoops, tiny-spear-earrings, tiny-spear-choker, sirena-pearl-necklace-16in, small-eleanor-earrings, medium-eleanor-earrings, sirena-pearl-necklace-24in, large-eleanor-earrings, sirena-pearl-necklace-30in, large-spear-pendant, small-spear-pendant, droplet-earrings-in-carnelian, leaf-brooch, ss18-leaf-earrings, droplet-earrings-in-onyx";
                let preOrder = "rinba-cuff,chandelier-earrings-in-onyx,vienna-earrings-in-onyx,chandelier-choker-in-onyx,large-full-moon-pendant-in-quartz,joan-bangle,large-angelyne-earrings-in-onyx,small-angelyne-earrings-in-onyx,egg-pendant-in-onyx,eileen-onyx-earrings,ice-necklace-in-quartz,spear-earrings-in-quartz,ice-collar-in-quartz,sphere-and-spear-earrings-in-quartz,large-spear-pendant-in-quartz,egg-choker-in-onyx,nautilus-cigarette-case-sapphire,noodle-earrings,hoop-earring,everyday-egg-pendant-in-onyx,medium-full-moon-pendant-in-quartz,edo-hoops,everyday-egg-choker-in-onyx,decadent-pearl-necklace,decadent-pearl-collar,tiny-spear-pendant-in-onyx,tiny-spear-hoops-in-onyx";

                let preOrderArray = preOrder.split(',');

                if (preOrderArray.includes(handle)) {
                  item.querySelector(".availability").innerHTML = "Pre-Order";
                } else {
                  console.log(item);
                  item.querySelector(".availability").innerHTML = "Made to Order";
                }
                //item.querySelector(".availability").innerHTML = "Made to Order";
              } else {
                item.querySelector(".availability").innerHTML = "Sold Out";
              }
            } else {
              //console.log(checkTwo + " + " + optionOneHandle + " and " + checkOne + " + " + optionTwoHandle);
            }
          });
        } else {
          theVariants.forEach(function (jtem, j) {
            let checkOne = convertToHandle(jtem.option1);
            let checkTwo = convertToHandle(jtem.option2);

            if(checkTwo == optionOneHandle && checkOne == optionTwoHandle){
              let inventory = jtem.inventory_quantity;
              let policy = jtem.inventory_policy;
              item.dataset.variantId = jtem.id;
              if(inventory > 0){
                item.querySelector('.availability').innerHTML = "In Stock";
              } else if(policy == 'continue'){
                // let preOrder = ["rising-moon-flask", "large-moon-pendant", "large-carnelian-pendant", "dusk-lighter-case", "medium-moon-pendant", "everyday-ring", "midnight-lighter-case", "small-moon-pendant-in-onyx", "long-dripping-stone-earrings-in-carnelian", "medium-moon-pendant-in-carnelian", "mixed-bead-necklace-in-carnelian-16in-1", "mixed-bead-necklace-in-carnelian-16in", "small-moon-pendant-in-carnelian", "dripping-stone-earrings-in-carnelian", "everyday-earrings-in-carnelian", "carnelian-mermaid-choker", "large-moon-pendant-in-onyx",  "medium-moon-pendant-in-onyx", "dawn-lighter-case", "mixed-bead-necklace-in-onyx-20", "mixed-bead-necklace-in-onyx-16", "everyday-earrings-in-onyx", "small-passante-earrings-in-white", "mixed-bead-necklace-in-onyx-47-5", "mixed-pearl-necklace-16", "mixed-pearl-necklace-47-5", "large-passante-earrings-in-white", "medium-passante-earrings-in-white", "mixed-pearl-necklace-20", "mixed-bead-necklace-in-carnelian-20in", "dripping-stone-earrings-in-vegetable-ivory", "long-dripping-stone-earrings-in-vegetable-ivory", "medium-angelika-earrings-in-vegetable-ivory", "small-angelika-earrings-in-vegetable-ivory", "pyramid-ring-in-onyx", "tilde-ring", "hoops", "small-moon-pendant", "small-angelika-earrings-in-carnelian", "godfather-ring-in-carnelian", "onyx-droplet-pendant", "onyx-droplet-earrings", "teardrop-pouch", "long-teardrop-pouch", "elegant-shoelace-choker-in-vegan-leather"];

                let preOrder = "rinba-cuff,chandelier-earrings-in-onyx,vienna-earrings-in-onyx,chandelier-choker-in-onyx,large-full-moon-pendant-in-quartz,joan-bangle,large-angelyne-earrings-in-onyx,small-angelyne-earrings-in-onyx,egg-pendant-in-onyx,eileen-onyx-earrings,ice-necklace-in-quartz,spear-earrings-in-quartz,ice-collar-in-quartz,sphere-and-spear-earrings-in-quartz,large-spear-pendant-in-quartz,egg-choker-in-onyx,nautilus-cigarette-case-sapphire,noodle-earrings,hoop-earring,everyday-egg-pendant-in-onyx,medium-full-moon-pendant-in-quartz,edo-hoops,everyday-egg-choker-in-onyx,decadent-pearl-necklace,decadent-pearl-collar,tiny-spear-pendant-in-onyx,tiny-spear-hoops-in-onyx";

                let preOrderArray = preOrder.split(',');

                if (preOrderArray.includes(handle)) {
                  item.querySelector(".availability").innerHTML = "Pre-Order";
                } else {
                  console.log(item);
                  item.querySelector(".availability").innerHTML = "Made to Order";
                }
                //item.querySelector(".availability").innerHTML = "Made to Order";
              } else {
                item.querySelector(".availability").innerHTML = "Sold Out";
              }
            } else {
              //console.log(checkTwo + " + " + optionOneHandle + " and " + checkOne + " + " + optionTwoHandle);
            }
          });
        }
      });
    });
  };

  let removeMaterial = function (x) {
    materialVariants.forEach(function (item, i) {
      if (x != i) {
        item.classList.remove("active");
      }
    });
  };

  let setVariantId = function(handle, selectedVariantId, selectedVariantName){
    let finalVariant = selectedVariantId;
      let dirtyName = "/products/" + handle + ".js";
      jQuery.getJSON(dirtyName, function (product) {
        let theVariants = product.variants;

        theVariants.forEach(function (jtem, j) {
          if (jtem.id == finalVariant) {

              if (jtem.inventory_quantity > 0 || jtem.inventory_policy == "continue") {
                document.querySelector(".toggle-options-btn").innerHTML = selectedVariantName + '<span class="arrow"></span>';
                let dirtyPrice = jtem.price;
                let roundedPrice = dirtyPrice / 100;
                let formatPrice = roundedPrice.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
                let replaceText = '<span id="item-price" class="animate">$ ' + formatPrice + '</span> - <span id="item-status" class="animate">Add To Cart</span>'
                let atcReplace = atcBtn.querySelector('.inner-btn');
                animateOnChange(atcReplace, replaceText);
                atcBtn.dataset.variantId = jtem.id;
                varWrap.classList.remove("open");
              } else {
                document.querySelector(".toggle-options-btn").innerHTML = selectedVariantName + '<span class="arrow"></span>';
                let atcReplace = atcBtn.querySelector('.inner-btn');
                animateOnChange(atcReplace, "Sold Out");
                //atcBtn.innerHTML = "Sold Out";
                atcBtn.dataset.variantId = "";
                varWrap.classList.remove("open");
              }
          }
        });
      });

  }

  setMultiDefaults(atcBtn, productHandle);

  //Set the second option when user clicks it
  let theSizes = document.querySelectorAll('.single-variant-option');
  theSizes.forEach(function(item, i){
    item.addEventListener('click', function(event){
      event.preventDefault();
      atcBtn.dataset.variantTwo = item.querySelector(".size").innerHTML;
      atcBtn.dataset.variantId = item.dataset.variantId;
      setVariantId(productHandle, item.dataset.variantId, atcBtn.dataset.variantTwo); 
    });
  });

  //Toggle between materials
  let materialVariants = document.querySelectorAll(".line-options a");
  materialVariants.forEach(function(item,i){
    item.addEventListener('click', function(event){
      event.preventDefault();
      document.querySelector(".toggle-options-btn").innerHTML = defaultDropdownText;
      removeMaterial(i);
      atcBtn.dataset.variantOne = item.innerText;
      atcBtn.dataset.variantTwo = "";
      atcBtn.dataset.variantId = "";
      item.classList.add('active');
      setMultiDefaults(atcBtn, productHandle);
      let atcReplace = atcBtn.querySelector(".inner-btn");
      animateOnChange(atcReplace, "Make a Selection");
      //atcBtn.innerHTML = "Make a Selection";
    });
  });
}

if(varOptions){
  let toggleOptBtn = varWrap.querySelector(".toggle-options-btn");
  let defaultToggle = toggleOptBtn.innerHTML;

  toggleOptBtn.addEventListener("click", function (event) {
    event.preventDefault();
    toggleOptBtn.innerHTML = defaultToggle;
    varWrap.classList.toggle("open");
  });
}

//Add to cart
atcBtn.addEventListener('click', function(event){
  event.preventDefault();
  let variantID = atcBtn.dataset.variantId;
  let variantInt = parseInt(variantID);
  if (variantID != "" && variantID != null) {
    CartJS.addItem(variantInt, 1, {});
  } else {
    let atcReplace = atcBtn.querySelector(".inner-btn");
    animateOnChange(atcReplace, "Make a Selection");
    //atcBtn.innerHTML = "Make a Selection";
    console.log("Something went wrong");
  }
});